import { z } from 'zod';
import { errorEnvelopeSchema } from './schemas/common.js';
export class ApiError extends Error {
    code;
    status;
    requestId;
    details;
    constructor(args) {
        super(args.message);
        this.name = 'ApiError';
        this.code = args.code;
        this.status = args.status;
        this.requestId = args.requestId;
        this.details = args.details;
    }
}
/** Thrown when the server's response does not match the contract. */
export class ContractError extends Error {
    path;
    issues;
    constructor(path, issues) {
        super(`Response from ${path} did not match its schema`);
        this.path = path;
        this.issues = issues;
        this.name = 'ContractError';
    }
}
export function createClient(options = {}) {
    const baseUrl = options.baseUrl ?? '/api';
    const doFetch = options.fetch ?? globalThis.fetch.bind(globalThis);
    async function request(path, opts) {
        const res = await doFetch(`${baseUrl}${path}`, {
            method: opts.method ?? 'GET',
            credentials: 'same-origin',
            headers: {
                accept: 'application/json',
                ...(opts.body === undefined ? {} : { 'content-type': 'application/json' }),
            },
            ...(opts.body === undefined ? {} : { body: JSON.stringify(opts.body) }),
            ...(opts.signal ? { signal: opts.signal } : {}),
        });
        const text = await res.text();
        const json = text === '' ? null : JSON.parse(text);
        if (!res.ok) {
            const envelope = errorEnvelopeSchema.safeParse(json);
            if (res.status === 401)
                options.onUnauthorized?.();
            if (envelope.success) {
                throw new ApiError({
                    code: envelope.data.error.code,
                    message: envelope.data.error.message,
                    status: res.status,
                    requestId: envelope.data.error.requestId,
                    details: envelope.data.error.details,
                });
            }
            throw new ApiError({ code: 'internal', message: res.statusText, status: res.status });
        }
        const parsed = opts.schema.safeParse(json);
        if (!parsed.success)
            throw new ContractError(path, parsed.error.issues);
        return parsed.data;
    }
    return { request };
}
//# sourceMappingURL=client.js.map